<div id="modalWrapper" [ngClass]="{'hidden': hidden}">
	<div class="modal-header">
		<h5 class="modal-title">{{title}}</h5>
		<div id="right">
			<div id="legenda">
				<div>
					<i style="color: gray" class="fa-solid fa-pen"></i>
					Antwoord ingevuld
				</div>
				<div>
					<i _ngcontent-rla-c113="" class="fa-solid fa-circle-check PERFECT"></i>
					Antwoord goed
				</div>
				<div>
					<i _ngcontent-rla-c113="" class="fa-solid fa-circle-check CORRECT"></i>
					Antwoord voldoende
				</div>
				<div>
					<i _ngcontent-rla-c113="" class="fa-solid fa-circle-check WRONG"></i>
					Antwoord onvoldoende
				</div>
			</div>
			<button type="button" class="close" aria-label="Close" (click)="close()">
				<i class="fa-solid fa-xmark"></i>
			</button>
		</div>
	</div>
	<div class="modal-body">
		<div>
			<table>
				<thead>
					<tr>
						<th class="sticky">{{classroomDetails.name}} ({{classroomDetails.defaultStudyLevel}})</th>
						<ng-container *ngFor="let question of chunks(answerData.questions); let i = index">
							<th class="clickable" (click)="showQuestionOverview(question)">
								<i class="fa-solid fa-square-arrow-up-right" style="margin-right: 5px;"></i> <span [innerHTML]="question.questionLetter"></span> <i class="fa-solid fa-spinner" *ngIf="question['loading'] == true"></i>
							</th>
						</ng-container>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let student of answerData.students">
						<th class="clickable sticky" [ngClass]="{'isEmail' : isEmailValid(student['studentName'])}" (click)="showStudentOverview(student, student['student'])">
							<i class="fa-solid fa-eye"></i> {{student['studentName']}} <span *ngIf="classroomDetails.defaultStudyLevel != student['studentStudyLevel']">({{student['studentStudyLevel']}})</span><i class="fa-solid fa-spinner" *ngIf="student['loading'] == true"></i>
						</th>
		
						<ng-container *ngFor="let answer of student['answers']">
							<td class="{{answer.answerStatus}}" *ngIf="answer.answerValue != null  && answer.answerStatus != ''"><i
									class="fa-solid fa-circle-check"></i></td>
		
							<td *ngIf="answer.answerValue != null && answer.answerStatus == ''"><i style="color: gray" class="fa-solid fa-pen"></i></td>
		
							<td *ngIf="answer.answerValue == null"></td>
						</ng-container>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>